import { Box, HStack, Text, VStack, Divider } from "@chakra-ui/react";
import { CurrencyText, EmptyState } from "../../../shared/ui";
import { DIAS_SEMANA_ABREV } from "../../../shared/lib/date";
import { parseIsoDate } from "../utils/calendarViews";
import ShiftRow from "./ShiftRow";
import CalendarEventRow from "./CalendarEventRow";

const dayLabel = (iso) => {
  const [, month, day] = iso.split("-");
  return `${DIAS_SEMANA_ABREV[parseIsoDate(iso).getDay()]}, ${day}/${month}`;
};

// Visão Lista: o período em ordem cronológica, um bloco por dia que tem plantão ou
// compromisso, com o subtotal dos plantões do dia e o total do período (já filtrados).
// `list` vem de buildDayList.
export default function DayListView({ list, today, vinculosById, shiftActions, onEditEvent, onDeleteEvent }) {
  if (list.days.length === 0) {
    return <EmptyState title="Nada neste período" description="Nenhum plantão ou compromisso para os filtros escolhidos." />;
  }

  return (
    <VStack align="stretch" spacing={4}>
      <HStack justify="space-between" px={1} data-testid="day-list-total">
        <Text fontSize="sm" color="app-muted-fg">
          Total do período · {list.count} plantão(ões)
        </Text>
        <Text fontWeight="semibold">
          <CurrencyText value={list.total} />
        </Text>
      </HStack>
      {list.days.map((day) => (
        <Box key={day.date} as="section" aria-label={dayLabel(day.date)} border="1px solid" borderColor={day.date === today ? "primary" : "app-border"} borderRadius="md" p={3}>
          <HStack justify="space-between" mb={2}>
            <Text fontSize="sm" fontWeight="semibold" color={day.date === today ? "accent-text" : undefined}>
              {dayLabel(day.date)}
            </Text>
            {day.shifts.length > 0 ? (
              <Text fontSize="sm" fontWeight="semibold" data-testid="day-subtotal">
                <CurrencyText value={day.subtotal} />
              </Text>
            ) : null}
          </HStack>
          <VStack align="stretch" spacing={3} divider={<Divider />}>
            {day.shifts.map((shift) => (
              <ShiftRow key={shift.id} shift={shift} vinculo={vinculosById[shift.vinculo_id]} actions={shiftActions} />
            ))}
            {day.events.map((event) => (
              <CalendarEventRow key={`compromisso-${event.id}`} event={event} onEdit={onEditEvent} onDelete={onDeleteEvent} />
            ))}
          </VStack>
        </Box>
      ))}
    </VStack>
  );
}
